import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { AccountDataRequest } from '@app/models/account-data-request.model'
import { AccountDataResponse } from '@app/models/account-data-response.model'
import { Address } from '@app/models/address'
import { QuoteSession } from '@app/models/quote-session.model'
import { getEndpoint } from '@app/utils/get-endpoint'
import { catchError, map, Observable, throwError } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class BusinessRulesService {
	#businessRules: string = 'BusinessRules'

	public boolMapper: Map<string, boolean> = new Map([
		['true', true],
		['false', false],
	])

	constructor(private http: HttpClient) {}

	public getAvailableDiscounts(session: QuoteSession): Observable<QuoteSession> {
		return this.http.post<QuoteSession>(
			getEndpoint([this.#businessRules, 'GetAvailableDiscounts']),
			session
		)
	}

	public getAccountData(request: AccountDataRequest): Observable<AccountDataResponse> {
		return this.http.post<AccountDataResponse>(
			getEndpoint([this.#businessRules, 'GetAccountData']),
			request
		)
	}

	/** /api/v1/BusinessRules/ActivatePolicyQuote */
	public activatePolicyQuote(request: QuoteSession): Observable<QuoteSession> {
		return this.http.post<QuoteSession>(
			getEndpoint([this.#businessRules, 'ActivatePolicyQuote']),
			request
		)
	}

	/** /api/v1/BusinessRules/AddressValidation */
	public validateAddress(request: Address): Observable<boolean> {
		return this.http
			.post(getEndpoint([this.#businessRules, 'AddressValidation']), request, {
				responseType: 'text',
			})
			.pipe(
				map((res) => {
					return this.boolMapper.get(res) ?? true
				}),
				catchError((err) => {
					err.error ||= 'There was an error'

					return throwError(() => err.error)
				})
			)
	}

	/** /api/v1/BusinessRules/EmailValidation */
	public validateEmail(email: string): Observable<boolean> {
		return this.http
			.post(
				getEndpoint([this.#businessRules, 'ValidateEmailAddress', `?emailAddress=${email}`]),
				{},
				{
					responseType: 'text',
				}
			)
			.pipe(
				map((res) => {
					return this.boolMapper.get(res) ?? false
				}),
				catchError((err) => {
					console.log('Email validation error:', err)
					return throwError(() => err.error)
				})
			)
	}
}
